const BB_REFERRAL_KEY = 'bb_rewards_referral';
const BB_REFERRAL_TTL = 30 * 24 * 60 * 60 * 1000;

const validReferral = (value) => typeof value === 'string' && /^[A-Z0-9-]{6,32}$/i.test(value);

const referralFromStorage = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(BB_REFERRAL_KEY) || 'null');
    if (!stored || !validReferral(stored.code) || Date.now() - stored.savedAt > BB_REFERRAL_TTL) return null;
    return stored.code.toUpperCase();
  } catch {
    return null;
  }
};

const persistReferral = (code) => {
  try {
    localStorage.setItem(BB_REFERRAL_KEY, JSON.stringify({ code, savedAt: Date.now() }));
  } catch {
    // Storage can be blocked; the current cart attribution still proceeds.
  }
};

const attachReferralToCart = async () => {
  const url = new URL(window.location.href);
  const incoming = url.searchParams.get('ref');
  const code = validReferral(incoming) ? incoming.toUpperCase() : referralFromStorage();
  if (!code) return;
  persistReferral(code);
  await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: { _bb_referral_code: code } }),
    keepalive: true,
  }).catch(() => {});
};

attachReferralToCart();
